import {createAction, ActionFunction1, Action} from 'redux-actions';
import {PlayerStatus} from '@accurate-player/accurate-player-core';
import {TimelineMarker} from 'VideoAudioQC/Timeline/TimelineTypes';
import {AdPreview} from '../AccuratePlayerTypes';

export const PLAYER_STATUS_SET = 'PLAYER_STATUS_SET';

export const AD_PREVIEWS_SET = 'AD_PREVIEWS_SET';

export const SHOW_HOTKEY_DIALOG = 'SHOW_HOTKEY_DIALOG';

export const AD_ON_PLAYING_FRAME_SET = 'AD_ON_PLAYING_FRAME_SET';

export const SHOW_SAFE_MARGINS = 'SHOW_SAFE_MARGINS';

export type AdPreviewOrUndefined = AdPreview[] | undefined;

export interface AccuratePlayerPayload {
    playerStatus: PlayerStatus;
}

export interface AdPreviewPayload {
    adPreviews: AdPreviewOrUndefined;
}

export interface ShowHotkeysPayload {
    showHotkeys: boolean;
}

export interface ShowSafeMarginsPayload {
    showSafeMargins: boolean;
}

export type AdOnPlayingFramePayload = TimelineMarker | undefined;

export const setPlayerStatusAction = createAction(
    PLAYER_STATUS_SET,
    (playerStatus: PlayerStatus): AccuratePlayerPayload => {
        return {
            playerStatus,
        };
    }
);

export const setAdPreviewsAction = createAction(
    AD_PREVIEWS_SET,
    (adPreviews?: AdPreview[]): AdPreviewPayload => {
        return {
            adPreviews,
        };
    }
);

export const setShowHotkeysAction = createAction(
    SHOW_HOTKEY_DIALOG,
    (showHotkeys: boolean): ShowHotkeysPayload => {
        return {
            showHotkeys,
        };
    }
);

export const setAdOnPlayingFrameAction = createAction(
    AD_ON_PLAYING_FRAME_SET,
    (adOnPlayingFrame?: TimelineMarker): AdOnPlayingFramePayload => {
        return adOnPlayingFrame;
    }
);

export const setShowSafeMarginsAction = createAction(
    SHOW_SAFE_MARGINS,
    (showSafeMargins: boolean): ShowSafeMarginsPayload => {
        return {
            showSafeMargins,
        };
    }
);

export type SetPlayerStatus = (playerStatus: PlayerStatus) => void;

export type SetAdPreview = ActionFunction1<
    AdPreviewOrUndefined,
    Action<AdPreviewPayload>
>;

export type SetShowHotkeys = ActionFunction1<boolean, Action<ShowHotkeysPayload>>;

export type SetAdOnPlayingFrame = ActionFunction1<
    TimelineMarker | undefined,
    Action<AdOnPlayingFramePayload>
>;

export type SetShowSafeMargins = ActionFunction1<boolean, Action<ShowSafeMarginsPayload>>;
